import React, { FC } from "react";
import { faRobot, faTag } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Group, Tooltip } from "@mantine/core";

import styles from "./CodeLocationIconList.module.css";

export interface AiTagIconProps {
  aiTag: string;
}

export const AiTagIcon: FC<AiTagIconProps> = ({ aiTag }) => {
  return (
    <Tooltip
      label={
        <div>
          <FontAwesomeIcon icon={faRobot} fixedWidth /> Assistant thinks this
          file relates to {aiTag}.
        </div>
      }
      withArrow
      position="top"
      withinPortal
    >
      <Group gap={6} wrap="nowrap" className={styles.group}>
        <FontAwesomeIcon icon={faTag} size="sm" />
        <div>{aiTag}</div>
      </Group>
    </Tooltip>
  );
};
